export default __webpack_public_path__ + "7d0c862b2a1a8643db618e89452e1435.svg";